export default __webpack_public_path__ + "img/shape-oval-small.5d38073c.svg";